module.exports = __webpack_public_path__ + "static/media/react-routes.aeb861fd.webp";